// Empire Jamaica Fusion — Catering page data

export const EVENT_TYPES = [
    {
        id: "weddings",
        title: "Weddings",
        note: "Elegant receptions, rehearsal dinners, and intimate ceremonies designed around your vision.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/cgxmtqev_90DA897D-570F-4536-9634-1812C7F856DA.PNG",
        guestRange: "30 – 250",
    },
    {
        id: "corporate",
        title: "Corporate Events",
        note: "Executive lunches, client appreciation events, team celebrations, and professional gatherings with elevated Caribbean cuisine.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/vp3l83vv_69815085-246A-45C7-B581-5675DC197104.PNG",
        guestRange: "20 – 300",
    },
    {
        id: "birthdays",
        title: "Birthday Celebrations",
        note: "Milestone birthdays, surprise parties, and unforgettable celebrations designed to bring people together.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/akevgric_74098083-15F2-457E-8577-0FBE43FFCA51.PNG",
        guestRange: "10 – 100",
    },
    {
        id: "family",
        title: "Family Gatherings",
        note: "Family reunions, anniversaries, baby showers, and special moments centered around exceptional food and hospitality.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/2j9ynage_Family_Gathering_event.PNG",
        guestRange: "12 – 150",
    },
    {
        id: "holidays",
        title: "Holiday Parties",
        note: "Holiday celebrations, seasonal gatherings, and festive events with warm Caribbean hospitality.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/tt3kmf0p_0FB7FE96-C940-4F9B-87DF-C29E988B00E6.PNG",
        guestRange: "20 – 200",
    },
    {
        id: "private-chef",
        title: "Private Dining Experiences",
        note: "An intimate, elevated dining experience curated for small groups, private celebrations, and special occasions.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/3a3gg55y_4F31409C-D6F5-4DDA-9779-4F8F44844AA6.PNG",
        guestRange: "4 – 16",
    },
];

export const SIGNATURES = [
    {
        name: "Jerk Chicken",
        note: "Pimento-wood marinated chicken charred over open flame with authentic Jamaican jerk seasoning.",
        image:
            "https://static.prod-images.emergentagent.com/jobs/c2b7593f-ae8f-4892-a9ba-b424e7885b58/images/ac8d89d2beb6f6181caed66430f6c32867fb9c236253afcb2b1cb0f8c9971530.png",
        tag: "Signature",
    },
    {
        name: "Braised Oxtail",
        note: "Slow-braised Jamaican oxtail simmered for hours in rich gravy with butter beans and island spices.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/wfwhbttq_20E119FE-48F8-4837-A259-B87021DF969B.PNG",
        tag: "House Classic",
    },
    {
        name: "Curry Chicken",
        note: "Traditional Jamaican curry chicken with tender potatoes and rich island curry flavors.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/jqstmtoi_8297D13F-5615-4362-B284-285AC91D213A.PNG",
        tag: "Traditional",
    },
    {
        name: "Escovitch Fish",
        note: "Crispy fried fish topped with authentic Jamaican escovitch vegetables and tangy pepper sauce.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/bwzczki2_6AED80A2-E5AD-4A8F-A910-849ACAE56061%202.PNG",
        tag: "Coastal",
    },
    {
        name: "Garlic Shrimp",
        note: "Succulent shrimp sautéed with peppers, scallions, garlic, and island spices in a rich buttery sauce.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/zz8oh899_A99AA3D4-A647-4577-A454-4AACC94A37F1%202.PNG",
        tag: "Crowd Favorite",
    },
    {
        name: "Vegan Crab Cakes",
        note: "House-made chickpea and heart of palm cakes served with fresh vegetables, sweet plantains, greens, and signature sauce.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/w5hkekjx_E4A3D5A3-08FA-4657-BB26-72773561DDAE%202.PNG",
        tag: "Plant-Based",
    },
];

export const TRUST_STATS = [
    { value: "5 Years", label: "Serving the Hudson Valley", note: "Rooted in Poughkeepsie" },
    { value: "186+", label: "Google Reviews & Counting", note: "From guests across the valley" },
    { value: "4.8★", label: "Google Rating", note: "Consistently top-rated" },
    { value: "100% Authentic", label: "Recipes carried from Jamaica", note: "Cooked the way they should be" },
];

// Builder source data
export const PROTEINS = [
    { id: "jerk-chicken", label: "Jerk Chicken" },
    { id: "curry-chicken", label: "Curry Chicken" },
    { id: "brown-stew-chicken", label: "Brown Stew Chicken" },
    { id: "oxtail", label: "Braised Oxtail" },
    { id: "curry-goat", label: "Curry Goat" },
    { id: "escovitch-snapper", label: "Escovitch Snapper" },
    { id: "ginger-salmon", label: "Ginger Soy Salmon" },
    { id: "coconut-shrimp", label: "Coconut Shrimp" },
    { id: "curry-chickpea", label: "Curry Chickpea Stew", vegan: true },
    { id: "trini-jerk-chickless", label: "Trini Jerk Chickless", vegan: true },
];

export const SIDES = [
    { id: "rice-peas", label: "Gungo Peas & Rice" },
    { id: "plantains", label: "Fried Sweet Plantains" },
    { id: "mac-cheese", label: "Wicked Mac & Cheese" },
    { id: "collards", label: "Collard Greens" },
    { id: "veggies", label: "Sautéed Vegetables" },
];

export const BEVERAGES = [
    { id: "tropical-rhythm", label: "Tropical Rhythm Juice" },
    { id: "coconut-water", label: "100% Coconut Water" },
    { id: "jamaican-coffee", label: "Jamaican Coffee" },
    { id: "sorrel", label: "Seasonal Sorrel" },
    { id: "soft-drinks", label: "Soft Drinks" },
    { id: "water", label: "Water / Pellegrino" },
];

export const SERVICE_STYLES = [
    {
        id: "buffet",
        label: "Buffet",
        note: "Self-serve display, attended by staff. Classic and convivial.",
    },
    {
        id: "trays",
        label: "Drop-Off Trays",
        note: "Hot, foil-wrapped trays delivered ready to serve. Ideal for office events.",
    },
    {
        id: "plated",
        label: "Plated Service",
        note: "Each course brought to seat by uniformed staff. Wedding-tier presentation.",
    },
];

export const EVENT_OPTIONS = [
    "Wedding",
    "Corporate / Office",
    "Birthday",
    "Anniversary",
    "Family Gathering",
    "Holiday Party",
    "Memorial",
    "Other",
];
